import Flickity from 'flickity';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);


export default {
  init($element) {
  },
  finalize($element) {
    if ($element.find('.latest-news-carousel')) {
      const latestNewsCarousel = new Flickity($element.find('.latest-news-carousel').get()[0], {
        // adaptiveHeight: true,
        autoPlay: false,
        prevNextButtons: false,
        pageDots: false,
        contain: true,
        on: {
          ready: function() {
            window.dispatchEvent(new Event('resize')); // Quickfix for sizing issue
          },
        },
      });

      const newsItems = $element.find('.news-item').get();

      gsap.fromTo(newsItems, {
        autoAlpha: 0,
        y: 10,
      }, {
        scrollTrigger: {
          trigger: newsItems,
          start: 'top bottom',
        },
        autoAlpha: 1,
        y: 0,
        stagger: 0.2,
        duration: .6,
      })
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/home/latestNews.js